import { Component, OnInit, ElementRef, ChangeDetectorRef, ComponentFactoryResolver, ViewRef, ViewChild, ComponentRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityServiceForMedicalService } from '../../services/utility-service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import { QuoteDataCaptureService, FormValidationsService, UtilService, SERVICE_END_POINT, AuthService } from 'src/app/shared';
import * as UserDataConfig from '../../../user-details/config/user-data.config';
import { AlertModal } from 'src/app/model/alert';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { LifeStyleQuestion, HealthLifestyle, Sections } from '../../model/lifestyle.model';
import { Subscription } from 'rxjs';
import { UnderWritingData, QuestionsToAPI, AnnuitantMedicalConditions } from '../../model/lifestyle.post.model';
import { MandatoryQuestionsDirective } from '../../directives/mandatory-questions-directive';
import { ControlTypesComponent } from '../control-types/control-types.component';
import { SyncService } from '../../services/sync.service';
import { AdItem } from '../ad-item.component';
import * as LifeStyleActions from '../../store/actions/lifestyle.action';
import { MedicationQuestionStoreModel, InvalidCtlNameObj } from '../../model/mcUserJourney.model';
import { MEDICAL_UW_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { MEDICAL_UW_HO_URL } from '../../../../shared';
import { Observable } from 'rxjs/internal/Observable';
import { RefNo } from 'src/app/model/ngrx';
import * as RefNumberActions from '../../../../store/actions/reference-number.actions';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

const jsonFormat = ".json";

@Component({
  selector: 'app-activities-of-daily-living',
  templateUrl: './activities-of-daily-living.component.html',
  styleUrls: ['./activities-of-daily-living.component.scss']
})
export class ActivitiesOfDailyLivingComponent implements OnInit {
  public contentData: any;
  // protected userInputDetail = UserDataConfig.ElementsConfig;
  protected userForm: UntypedFormGroup;

  cmsData: any;
  public userInputDetail = UserDataConfig.ElementsConfig;
  displayAlert = false;
  displayPage = true;
  protected alertDiabetesModalConfig: AlertModal;
  private sectionsList: Sections[] = [];
  private questionToDisplayForADL: LifeStyleQuestion[];
  private medicalConditionPayload: QuestionsToAPI[];
  allowStoresubscribe: boolean;
  private lifeStyleFromStoreObsSubscription: Subscription;
  private lifeStylePayloadFromStore: UnderWritingData;
  @ViewChild(MandatoryQuestionsDirective, { static: true }) mandatoryQuestionsDir: MandatoryQuestionsDirective;
  public componentRefOfControlType: ComponentRef<ControlTypesComponent>;
  public lifestyleForm: UntypedFormGroup;
  private underWritingData: UnderWritingData;
  jsonObj: HealthLifestyle;
  private indexToSearchFromStore: number;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  isHOView = false;
  private CMSData;
  private rangeValidationData: any;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  editMode: boolean;
  constructor(private fb: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public el: ElementRef,
    private cdRef: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private healthService: HealthService,
    public utilityServiceForMedicalService: UtilityServiceForMedicalService,
     //changed to public to access in html file
    private syncService: SyncService,
    private store: Store<AppState>,
    private quoteDatacaptureService: QuoteDataCaptureService, private utilService: UtilService, private authService: AuthService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.activitiesOfLiving;
    this.isHOView = this.router.url.includes('ho-underwriting') ? true : false;
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        // this.quoteRefNo = val[0]['quoteReferenceNumber'];
        if (this.referenceNumber && this.referenceNumber.editMode) {
          this.editMode = true;
          this.userInputDetail['buttonConfig']['label'] = 'Done';
          this.userInputDetail['buttonConfig']['name'] = 'Done';
          // this.personalFormEdit = JSON.parse(JSON.stringify(this.personDetail));
        } else {
          this.editMode = false;
          this.userInputDetail['buttonConfig']['label'] = 'Next';
          this.userInputDetail['buttonConfig']['name'] = 'Next';
        }
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.alertDiabetesModalConfig = this.contentData.modalDiabetesMCConfig;
    //    this.initiateLifestyleFormData();
    this.setLifestyleForm();
    this.getLifestyleRange();

    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });

    if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
      this.contentData.header = this.contentData.dependantHeader;
    } else {
      this.contentData.header = this.contentData.header;
    }
  }
  ngAfterViewInit() {
    //this.getLifestyleData();
    this.getDailyActivitiesData();
  }

  setLifestyleForm = () => {
    this.lifestyleForm = this.fb.group({

    });
    //console.log('adl form  => ', this.lifestyleForm);
  }

  getDailyActivitiesData() {
    this.healthService.getMedicalConditionJson("DailyLiving.json")
      .subscribe(res => {
        let questionToDisplayObj: LifeStyleQuestion[] = [];
        this.jsonObj = res;
        this.sectionsList = this.jsonObj.section;
        this.syncService.setMedicalConditionJson(this.sectionsList);
        this.sectionsList.forEach(sec => {
          let temp = sec.question.filter(res => res.dcjCustomerDisplay === 'Yes' && res.mandatoryInitialDisplay === 'Yes');
          temp.forEach(ques => {
            questionToDisplayObj.push(ques);
          });
        });
        this.questionToDisplayForADL = questionToDisplayObj;
        this.allowStoresubscribe = true;
        this.getquestionToDisplayForADL();
        if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
          this.cdRef.detectChanges();
        }
      });
  }


  getquestionToDisplayForADL() {

    this.lifeStyleFromStoreObsSubscription = this.store.select(STORE_VAL.lifestyle).subscribe(res => {
      if (this.allowStoresubscribe) {
        if (res.length > 0) {
          this.lifeStylePayloadFromStore = res[0];
          if (this.lifeStylePayloadFromStore && (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant' && this.lifeStylePayloadFromStore.annuitantMedicalConditions
            && this.lifeStylePayloadFromStore.annuitantMedicalConditions.length > 0)) {
            this.lifeStylePayloadFromStore.annuitantMedicalConditions.forEach(element => {
              if (element.questionSetName === this.jsonObj.questionSetName) {
                this.indexToSearchFromStore = element.index;
              }
            });
            this.syncService.setPayLoadObjAndIndexFromStore(this.lifeStylePayloadFromStore, this.indexToSearchFromStore);
            this.renderUIBasedOnSelectedresponseValue();
            this.loadComponent(this.questionToDisplayForADL);
          } else if (this.lifeStylePayloadFromStore && (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant' && this.lifeStylePayloadFromStore.dependentMedicalConditions
            && this.lifeStylePayloadFromStore.dependentMedicalConditions.length > 0)) {
            this.lifeStylePayloadFromStore.dependentMedicalConditions.forEach(element => {
              if (element.questionSetName === this.jsonObj.questionSetName) {
                this.indexToSearchFromStore = element.index;
              }
            });
            this.syncService.setPayLoadObjAndIndexFromStore(this.lifeStylePayloadFromStore, this.indexToSearchFromStore);
            this.renderUIBasedOnSelectedresponseValue();
            this.loadComponent(this.questionToDisplayForADL);
          }
          else {
            //this.renderUIWithDefaultValues(); 
          }

        }
        else {
          this.renderUIWithDefaultValues();
          this.loadComponent(this.questionToDisplayForADL);
        }
      }
    });

  }

  renderUIWithDefaultValues() {
  }

  renderUIBasedOnSelectedresponseValue() {
    this.addResponseValueByUserToQuestionsList();

    // TODO: partial - quotes- go through json again whre next step values found and trigger the user action function();

  }




  getAnswerFromStore(questionId: string): QuestionsToAPI {
    let value: QuestionsToAPI;
    value = this.utilityServiceForMedicalService.getResponseValuesFromStore(questionId, this.lifeStylePayloadFromStore, this.indexToSearchFromStore);
    return value;
  }

  addResponseValueByUserToQuestionsList() {
    this.sectionsList.forEach(sec => {
      sec.question.forEach(qus => {
        let temp = this.getAnswerFromStore(qus.id);
        qus.responseValueByUser = temp ? temp.responseValue : undefined;
        // qus.defaultResponseValue = qus.responseValueByUser;
      });

    });
  }

  loadComponent(questionList: LifeStyleQuestion[]) {
    const adItem = new AdItem(ControlTypesComponent, {});
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(adItem.component);
    const viewContainerRef = this.mandatoryQuestionsDir.viewContainerRef;
    viewContainerRef.clear();
    this.componentRefOfControlType = viewContainerRef.createComponent(ControlTypesComponent);
    this.componentRefOfControlType.instance.controlTypeQuestionList = questionList;
    this.componentRefOfControlType.instance.lifeStylePayloadFromStoreObj = this.lifeStylePayloadFromStore;
    this.componentRefOfControlType.instance.parentForm = this.lifestyleForm;
    this.componentRefOfControlType.instance.indexStoredInUWDataObj = this.indexToSearchFromStore;
    let obj = new ParentFormAndElmModel(this.componentRefOfControlType.instance.parentForm, this.el,
      this.componentRefOfControlType.instance.cdRef, null);
    this.utilService.setParentFormToValidate(obj);
  }

  saveFormValues() {
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.underWritingData = new UnderWritingData();
    this.underWritingData.annuitantMedicalConditions = this.lifeStylePayloadFromStore.annuitantMedicalConditions ? this.lifeStylePayloadFromStore.annuitantMedicalConditions : [];
    this.underWritingData.dependentMedicalConditions = this.lifeStylePayloadFromStore.dependentMedicalConditions ? this.lifeStylePayloadFromStore.dependentMedicalConditions : [];
    this.underWritingData.riskAndStaticQuestion = this.lifeStylePayloadFromStore.riskAndStaticQuestion ? this.lifeStylePayloadFromStore.riskAndStaticQuestion: null;
    
    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {
      if (this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.annuitantMedicalConditions
        && this.lifeStylePayloadFromStore.annuitantMedicalConditions.length > 0) {
        if (this.indexToSearchFromStore) {
          this.lifeStylePayloadFromStore.annuitantMedicalConditions.forEach((element, index) => {
            if (element.index === this.indexToSearchFromStore) {
              //element.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload);
              //element.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload);
              element = {...element, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload)};
              element = {...element, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload)};
              // console.log("Check:::::" + element.status);
              // console.log(element.questions);
              //this.lifeStylePayloadFromStore.annuitantMedicalConditions[index] = element;
              this.lifeStylePayloadFromStore = {...this.lifeStylePayloadFromStore, annuitantMedicalConditions:[...this.lifeStylePayloadFromStore.annuitantMedicalConditions.slice(0,index),element, ...this.lifeStylePayloadFromStore.annuitantMedicalConditions.slice(index+1,this.lifeStylePayloadFromStore.annuitantMedicalConditions.length)]}

            }
          });
          this.underWritingData = {...this.underWritingData, annuitantMedicalConditions: this.lifeStylePayloadFromStore.annuitantMedicalConditions};
        } else {
          let tempAnnuitantMed: AnnuitantMedicalConditions = new AnnuitantMedicalConditions();
          // tempAnnuitantMed.questionSetName = this.jsonObj.questionSetName;
          // tempAnnuitantMed.index = this.lifeStylePayloadFromStore.annuitantMedicalConditions.length;
          // tempAnnuitantMed.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload);
          // tempAnnuitantMed.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload);
          tempAnnuitantMed = {...tempAnnuitantMed, questionSetName: this.jsonObj.questionSetName};
          tempAnnuitantMed = {...tempAnnuitantMed, index: this.lifeStylePayloadFromStore.annuitantMedicalConditions.length};
          tempAnnuitantMed = {...tempAnnuitantMed, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload)};
          tempAnnuitantMed = {...tempAnnuitantMed, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload)};

          // console.log("Check:::::" + tempAnnuitantMed.status);
          this.lifeStylePayloadFromStore = {...this.lifeStylePayloadFromStore, annuitantMedicalConditions: [...this.lifeStylePayloadFromStore.annuitantMedicalConditions, tempAnnuitantMed]};
          this.underWritingData.annuitantMedicalConditions = this.lifeStylePayloadFromStore.annuitantMedicalConditions;
        }
      }
    }
    else if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
      if (this.lifeStylePayloadFromStore && this.lifeStylePayloadFromStore.dependentMedicalConditions
        && this.lifeStylePayloadFromStore.dependentMedicalConditions.length > 0) {
        if (this.indexToSearchFromStore) {
          this.lifeStylePayloadFromStore.dependentMedicalConditions.forEach((element, index) => {
            if (element.index === this.indexToSearchFromStore) {
              // element.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload);
              // element.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload);
              element = {...element, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload)};
              element = {...element, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload)};
              //this.lifeStylePayloadFromStore.dependentMedicalConditions[index] = element;
              this.lifeStylePayloadFromStore = {...this.lifeStylePayloadFromStore, dependentMedicalConditions:[...this.lifeStylePayloadFromStore.dependentMedicalConditions.slice(0,index),element, ...this.lifeStylePayloadFromStore.dependentMedicalConditions.slice(index+1,this.lifeStylePayloadFromStore.dependentMedicalConditions.length)]}
            }
          });
          this.underWritingData = {...this.underWritingData, dependentMedicalConditions: this.lifeStylePayloadFromStore.dependentMedicalConditions};
        } else {
          let tempDependantMed: AnnuitantMedicalConditions = new AnnuitantMedicalConditions();
          // tempDependantMed.questionSetName = this.jsonObj.questionSetName;
          // tempDependantMed.index = this.lifeStylePayloadFromStore.dependentMedicalConditions.length;
          // tempDependantMed.status = this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload);
          // tempDependantMed.questions = this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload);
          tempDependantMed = {...tempDependantMed, questionSetName: this.jsonObj.questionSetName};
          tempDependantMed = {...tempDependantMed, index: this.lifeStylePayloadFromStore.dependentMedicalConditions.length};
          tempDependantMed = {...tempDependantMed, status: this.utilityServiceForMedicalService.getsStatusOfMedCond(this.medicalConditionPayload)};
          tempDependantMed = {...tempDependantMed, questions: this.utilityServiceForMedicalService.removedMandatoryResponseFromPayload(this.medicalConditionPayload)};

          //this.lifeStylePayloadFromStore.dependentMedicalConditions.push(tempDependantMed);
          this.lifeStylePayloadFromStore = {...this.lifeStylePayloadFromStore, dependentMedicalConditions: [...this.lifeStylePayloadFromStore.dependentMedicalConditions, tempDependantMed]};
          this.underWritingData.dependentMedicalConditions = this.lifeStylePayloadFromStore.dependentMedicalConditions;
        }
      }
    }
    this.store.dispatch(new LifeStyleActions.RemoveLifestyleResult(0));
    this.store.dispatch(new LifeStyleActions.AddLifestyleResult(this.underWritingData));
  }

  triggerPostQuotesAPI(isbackBtnClicked: boolean) {
    this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
      if (isbackBtnClicked) {
        //this.router.navigate(['/home/your-product-choice']);
      }
      else {
        // this.router.navigate([MEDICAL_UW_URL.annuitant.AMC]);
        //this.router.navigate([MEDICAL_UW_URL.annuitant.medicalConditions]);
        //this.router.navigate(['/home/your-dependant']);
      }
      if (this.isHOView) {
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.doctorDetails, MEDICAL_UW_HO_URL.dependant.dependantDoctorDetails)]);
      } else {
        // tslint:disable-next-line: max-line-length
        this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.doctorDetails, MEDICAL_UW_URL.dependant.dependantDoctorDetails)]);
      }
    },
      err => {

      });
  }

  preparePayload(isbackBtnClicked: boolean) {
    this.saveFormValues();
    this.triggerPostQuotesAPI(isbackBtnClicked);
  }

  extractFromFormObjAndPrepareBackendJson() {
    this.medicalConditionPayload = [];
    let tempActiveTabList = this.syncService.getTabSquareAsActive();
    if (tempActiveTabList && tempActiveTabList.length > 0) {
      tempActiveTabList.forEach(tab => {
        if (tab.isActive && tab.nextQuestionObjList) {
          this.utilityServiceForMedicalService.prepareCurrentActiveFormTabSquare(this.lifestyleForm, tab.nextQuestionObjList, tab.activeIndex, tab.tabQuestionId, null, null);
          // need to write logic to find the current tabindex and needs to be added in the recurance list
        }
      });

    }
    this.questionToDisplayForADL.forEach(mandatoryQuesObj => {
      let backendQuestionObjForMandatoryQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, mandatoryQuesObj, null);
      this.medicalConditionPayload.push(backendQuestionObjForMandatoryQues);
      let selectedValueForMandatoryQues = backendQuestionObjForMandatoryQues.responseValue;
      this.recursiveFunForDependentQuestion(selectedValueForMandatoryQues, mandatoryQuesObj, null);
    });
    //console.log(this.medicalConditionPayload);
  }

  recursiveFunForDependentQuestion(selectedValueForMandatoryQues: any, quesObj: LifeStyleQuestion, jsonToReferFromRec: string, isRecurrence?: boolean) {
    if (typeof selectedValueForMandatoryQues === 'string' && selectedValueForMandatoryQues && quesObj.responseValue && quesObj.responseValue.length > 0) {
      // for the values where response value can be one. like input , number, radiobtn (yes/no)
      this.prepareForDepQuestionsForResValueAsString(quesObj, selectedValueForMandatoryQues, jsonToReferFromRec, isRecurrence);
    }
    if (selectedValueForMandatoryQues === null && quesObj.responseValue === null && quesObj.nextStep && quesObj.nextStep.length > 0) {
      //  for dummy questions but it can contains nextstep questions. eg: grid
      this.prepareForDepQuestionsForResValueAsNull(quesObj, jsonToReferFromRec, isRecurrence);
    }
    /* if (Array.isArray(selectedValue) && mandatoryQuesObj.nextStep && mandatoryQuesObj.nextStep.length > 0) { //  for question which can have dummy questions but it can contains nextstep questions
      this.prepareForDepQuestionsForResValueAsNull(mandatoryQuesObj, payload);
    } */
  }

  prepareForDepQuestionsForResValueAsNull(quesObj: LifeStyleQuestion, jsonToReferFromRec: string, isRecurrence?: boolean) {
    let questionIdList: string[] = [];
    if (quesObj.nextStep && quesObj.nextStep.length > 0) {
      quesObj.nextStep.forEach(next => {
        if (next.nextStepValue) {
          next.nextStepValue.forEach(id => {
            questionIdList.push(id);
          });
        }
      });
      let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(questionIdList, jsonToReferFromRec);
      nextQuestionObjList.forEach(nextQuestionObj => {
        let referenceQueId: string = quesObj.id;
        let backendQuestionObjForDependentQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, nextQuestionObj, null);
        this.medicalConditionPayload.push(backendQuestionObjForDependentQues);
        if (backendQuestionObjForDependentQues.responseValue) {
          this.recursiveFunForDependentQuestion(backendQuestionObjForDependentQues.responseValue, nextQuestionObj, null);
        }
      });
    }
  }

  prepareForDepQuestionsForResValueAsString(quesObj: LifeStyleQuestion, selectedValue: string, jsonToReferFromRec: string, isRecurrence?: boolean) {
    let questionIdList: string[] = [];
    if (quesObj.nextStep) {
      quesObj.nextStep.forEach(next => {
        if (next.nextStepSelectedResponse === selectedValue && next.nextStepValue && next.nextStepType === 'File') {
          let tempQuestIds: string[] = next.nextStepValue;
          if (tempQuestIds && tempQuestIds.length > 0 && tempQuestIds[0].includes(jsonFormat)) {
            let jsonToRefer = tempQuestIds[0];
            let tempList = this.syncService.getRefJsonWithMappingQId();
            // recurrence logic starting here with MDQ001 from medication json
            tempList.forEach(element => {
              if (element.questionId === quesObj.id) {
                element.questionList.forEach(quesObj => {
                  let backendQuestionObjForMandatoryQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, quesObj, null);
                  backendQuestionObjForMandatoryQues.recurrenceInd = true;
                  backendQuestionObjForMandatoryQues.questionModels = [];

                  let recurrenceQuesListToApi: QuestionsToAPI[] = [];
                  let recurrenceQuesListFromUIStoreForGivenQues: MedicationQuestionStoreModel[] = this.utilityServiceForMedicalService.getRecurrenceListForGivenQues(quesObj, null);
                  recurrenceQuesListFromUIStoreForGivenQues.forEach(recQuesObjFromStore => {
                    recQuesObjFromStore.questionList.forEach(storeObj => {
                      recurrenceQuesListToApi.push(storeObj);
                    });
                  });
                  backendQuestionObjForMandatoryQues.questionModels = recurrenceQuesListToApi;
                  this.medicalConditionPayload.push(backendQuestionObjForMandatoryQues);
                });

              }
            });
          }
        }
        if (next.nextStepSelectedResponse === selectedValue && next.nextStepValue && next.nextStepType !== 'File') {
          let nextQuestionIdList: string[] = next.nextStepValue;
          let nextQuestionObjList: LifeStyleQuestion[] = this.utilityServiceForMedicalService.getQuestionListForGivenIds(nextQuestionIdList, jsonToReferFromRec);
          nextQuestionObjList.forEach(nextQuestionObj => {

            let referenceQueId: string = quesObj.id;
            let backendQuestionObjForDependentQues: QuestionsToAPI = this.utilityServiceForMedicalService.prepareBackendJson(this.lifestyleForm, nextQuestionObj, null);
            this.medicalConditionPayload.push(backendQuestionObjForDependentQues);
            this.recursiveFunForDependentQuestion(backendQuestionObjForDependentQues.responseValue, nextQuestionObj, null);
          });
        }
      });
    }
  }
  gotoNext = () => {
    if (this.editMode && this.userInputDetail.buttonConfig.name.toUpperCase() !== 'NEXT') {
      this.referenceNumber = {...this.referenceNumber, editMode: false};
      this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
      this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
      this.editMode = false;
      this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
    } else {
      this.displayAlert = true;
      if (true) { // disabling validation  purposefully since it not required to validate ADL questions
        // this.componentRefOfControlType.instance.validateForm()
        this.allowStoresubscribe = false;
        this.preparePayload(false);
        /*
        if (this.isHOView) {
          // tslint:disable-next-line: max-line-length
          this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_HO_URL.annuitant.doctorDetails, MEDICAL_UW_HO_URL.dependant.dependantDoctorDetails)]);
        } else {
          // tslint:disable-next-line: max-line-length
          this.router.navigate([this.utilityServiceForMedicalService.getUnderWritingNavigationURL(MEDICAL_UW_URL.annuitant.doctorDetails, MEDICAL_UW_URL.dependant.dependantDoctorDetails)]);
        }
        */

      } else {
        this.componentRefOfControlType.instance.throwValidation(this.lifestyleForm);
      }
    }
  }

  onBackClick() {
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
  }

  saveAfterLogin() {
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully()
    );
  }
  saveAfterLogout() {
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveProgress() {
    this.medicalConditionPayload = [];
    this.extractFromFormObjAndPrepareBackendJson();
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }

  /* checkIfAnyInvalidDataPresent(): boolean {
    let invalidDataPresent = false;
    let obj: InvalidCtlNameObj = this.utilityServiceForMedicalService.isInvalidDataFoundInForm(this.lifestyleForm);
    if (obj && obj.invalidDataPresent) {
      invalidDataPresent = obj.invalidDataPresent;
      this.componentRefOfControlType.instance.throwValidationForOneCtl(this.lifestyleForm, obj.ctlName);
    } else {
      invalidDataPresent = false;
    }
    return invalidDataPresent;
  } */

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }

  ngOnDestroy() {
    if (this.lifeStyleFromStoreObsSubscription) {
      this.lifeStyleFromStoreObsSubscription.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }

  getLifestyleRange() {
    this.healthService.getRangeValidation()
      .subscribe(res => {
        this.rangeValidationData = res.values;
        this.syncService.setRangeValidationJson(this.rangeValidationData);
      });
  }

  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    //console.log('changed value = ', this.contentData);
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_MedicalDetailsCapture;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.headerText = this.CMSData.string_MedicalDetailsCaptureSubtitleADL;

      }
    });
  }
  /** End of code block for CMS */
}
